import {
  USER_CREATE,
  USER_LIST,
  USER_UPDATE,
  USER_FILTER,
  USER_CREATE_SUCCESS,
  USER_LIST_SUCCESS,
  USER_REQUEST_FAILED,
  USER_UPDATE_SUCCESS,
} from "store/users/actionTypes";

export const userCreate = (user) => {
  return {
    type: USER_CREATE,
    payload: user,
  };
};

export const userList = () => {
  return {
    type: USER_LIST,
    payload: {},
  };
};

export const userFilter = (changeUrl) => {
  return {
    type: USER_FILTER,
    payload: { changeUrl },
  };
};

export const userUpdate = (id, data) => {
  return {
    type: USER_UPDATE,
    payload: { id, data },
  };
};

export const userCreateSuccess = (userCreated) => {
  return {
    type: USER_CREATE_SUCCESS,
    payload: userCreated,
  };
};

export const userListSuccess = (users) => {
  return {
    type: USER_LIST_SUCCESS,
    payload: users,
  };
};

export const userUpdateSuccess = (user) => {
  return {
    type: USER_UPDATE_SUCCESS,
    payload: user,
  };
};

export const userRequestFailed = (error) => {
  return {
    type: USER_REQUEST_FAILED,
    payload: error,
  };
};
